import { getTextBounds } from "@visactor/vrender-core";

import { isGreater, isLess, tau, normalizeAngle, polarToCartesian } from "@visactor/vutils";

import { traverseGroup } from "../util/common";

import { scale, length } from "../util";

export const clampRadian = (angle = 0) => {
    if (angle < 0) for (;angle < 0; ) angle += tau; else if (angle > 0) for (;angle > tau; ) angle -= tau;
    return angle;
};

export function isInRange(a, min, max) {
    return !isLess(a, min, 0, 1e-6) && !isGreater(a, max, 0, 1e-6);
}

export function getCircleLabelPosition(tickPosition, tickVector, text, style) {
    const labelBounds = getTextBounds(Object.assign({
        text: text
    }, style)), width = labelBounds.width(), height = labelBounds.height(), angle = clampRadian(Math.atan2(tickVector[1], tickVector[0])) - Math.PI, PI_3_4 = 3 * Math.PI / 4, PI_1_4 = Math.PI / 4, PI_1_2 = Math.PI / 2, baseX = tickPosition.x;
    let dx = 0;
    dx = isInRange(angle, -PI_3_4, -PI_1_4) ? ((angle + PI_3_4) / PI_1_2 - .5) * width : isInRange(angle, PI_1_4, PI_3_4) ? (.5 - (angle - PI_1_4) / PI_1_2) * width : Math.cos(angle) >= 0 ? .5 * width : .5 * -width;
    const x = baseX - dx, baseY = tickPosition.y;
    let dy = 0;
    dy = isInRange(angle, -PI_3_4, -PI_1_4) ? .5 * -height : isInRange(angle, PI_1_4, PI_3_4) ? .5 * height : Math.cos(angle) >= 0 ? (.5 - (PI_1_4 - angle) / PI_1_2) * height : (.5 - clampRadian(angle - PI_3_4) / PI_1_2) * height;
    return {
        x: x,
        y: baseY - dy
    };
}

export function getElMap(g) {
    const elMap = {};
    return traverseGroup(g, (el => {
        "group" !== el.type && el.id && (elMap[el.id] = el);
    })), elMap;
}

export function getVerticalCoord(point, vector) {
    return {
        x: point.x + vector[0],
        y: point.y + vector[1]
    };
}

export function getCircleVerticalVector(offset, point, center, inside = !1, axisInside = !1) {
    const vector = [ point.x - center.x, point.y - center.y ];
    return scale(vector, (inside ? -1 : 1) * (axisInside ? -1 : 1) * offset / length(vector));
}

export function angleLabelOrientAttribute(angle) {
    let align = "center", baseline = "middle";
    return align = (angle = normalizeAngle(angle)) >= Math.PI * (5 / 3) || angle <= Math.PI * (1 / 3) ? "left" : angle >= Math.PI * (2 / 3) && angle <= Math.PI * (4 / 3) ? "right" : "center", 
    baseline = angle >= Math.PI * (7 / 6) && angle <= Math.PI * (11 / 6) ? "bottom" : angle >= Math.PI * (1 / 6) && angle <= Math.PI * (5 / 6) ? "top" : "middle", 
    {
        align: align,
        baseline: baseline
    };
}

export function getPolarAngleLabelPosition(angle, center, radius, labelOffset, inside, text, style) {
    const point = polarToCartesian({
        x: 0,
        y: 0
    }, radius, angle), labelPoint = getVerticalCoord(point, getCircleVerticalVector(labelOffset, point, center, inside));
    return getCircleLabelPosition(labelPoint, getCircleVerticalVector(labelOffset || 1, labelPoint, center, inside), text, style);
}
//# sourceMappingURL=util.js.map